export default function Hero() {
  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-accent-100/70 via-background-50 to-background-50">
      {/* 装饰圆点 */}
      <div className="pointer-events-none absolute -left-24 top-10 h-72 w-72 rounded-full bg-primary-200/40 blur-2xl" />
      <div className="pointer-events-none absolute right-0 bottom-0 h-80 w-80 translate-x-1/3 rounded-full bg-accent-300/40 blur-2xl" />

      <div className="relative mx-auto grid max-w-6xl grid-cols-1 items-center gap-10 px-4 md:px-6 pt-10 pb-16 lg:grid-cols-2 lg:pt-14 lg:pb-20">
        <div className="w-full">
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-100/80 px-4 py-1.5 text-xs font-medium text-primary-700">
            <i className="ri-fire-fill text-primary-500" />
            娱乐瓜田 · 反转与后续实时追踪站
          </span>

          <h1 className="mt-6 font-heading text-4xl leading-tight text-foreground-950 md:text-5xl lg:text-[56px]">
            追一颗瓜
            <span className="block text-primary-500">看到它的反转与结果</span>
          </h1>

          <p className="mt-6 max-w-xl text-base leading-8 text-foreground-700 md:text-lg">
            <strong className="font-semibold text-foreground-950">每日有瓜</strong>为你持续跟进后续、最新进展与实锤结果，
            点开看瓜的<strong className="text-primary-600">下回分解</strong>，在刷不完的热搜里，不遗漏任何一颗瓜的最终走向。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#feed"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg bg-primary-500 text-background-50 hover:bg-primary-600 px-6 py-3 text-sm font-semibold transition-colors"
            >
              去追最新瓜
              <i className="ri-arrow-right-line" />
            </a>
            <a
              href="#reversal"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg border border-background-300 bg-background-50 text-foreground-800 hover:border-secondary-300 hover:bg-secondary-50 px-6 py-3 text-sm font-semibold transition-colors"
            >
              <i className="ri-loop-left-line text-secondary-600" />
              看反转专题
            </a>
          </div>

          <div className="mt-9 flex flex-wrap items-center gap-x-6 gap-y-3 text-sm text-foreground-600">
            <span className="inline-flex items-center gap-2">
              <i className="ri-flashlight-fill text-secondary-500" />
              今日新增 42 条跟进
            </span>
            <span className="inline-flex items-center gap-2">
              <i className="ri-shuffle-line text-accent-600" />
              8 颗瓜迎来反转
            </span>
            <span className="inline-flex items-center gap-2">
              <i className="ri-check-double-line text-primary-500" />
              全程区分进展与结果
            </span>
          </div>
        </div>

        <div className="relative w-full">
          <div className="relative mx-auto max-w-md lg:max-w-none">
            <img
              src="https://readdy.ai/api/search-image?query=Friendly%20editorial%20illustration%20of%20smartphone%20screen%20showing%20colorful%20news%20timeline%20and%20chat%20bubbles%2C%20surrounded%20by%20playful%20watermelon%20and%20melon%20slices%2C%20warm%20coral%20red%20and%20fresh%20green%20palette%2C%20cream%20background%2C%20clean%20modern%20flat%20style%2C%20lively%20and%20fun&width=860&height=940&seq=gua-hero-2026&orientation=portrait"
              alt="每日有瓜娱乐瓜田追踪站主题插画"
              className="w-full rounded-3xl border-4 border-background-50 object-cover"
            />
            <div className="absolute -left-3 top-6 inline-flex items-center gap-2 rounded-xl bg-background-50 px-3.5 py-2 text-xs shadow-soft md:-left-5">
              <i className="ri-loop-left-line text-secondary-500 text-base" />
              <span className="text-foreground-700">今日 3 次反转</span>
            </div>
            <div className="absolute -right-2 bottom-8 inline-flex items-center gap-2 rounded-xl bg-primary-500 px-3.5 py-2 text-xs text-background-50 shadow-soft md:-right-4">
              <i className="ri-check-double-line text-base" />
              实锤结果已更新
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}